import { render } from "./DynamicArgument.vue?vue&type=template&id=58065ece"
import script from "./DynamicArgument.vue?vue&type=script&lang=js"
export * from "./DynamicArgument.vue?vue&type=script&lang=js"
script.render = render

export default script